import { Container, Tooltip } from "./styles";
import { useState } from "react";
import { SkeletonText } from "../SkeletonListaDemandas/styles";

export interface IAbaDeDenanda{
    id: number;
    label: string;
    contador: number;
    status: string[];
}

export default function AbaDeDemandas({
    dadosAba,
    selecionaAba,
    abaAtiva,
    isFirst,
    isLast,
    loading = false
}: {
    dadosAba: IAbaDeDenanda;
    selecionaAba: (aba: IAbaDeDenanda) => void;
    abaAtiva: boolean;
    isFirst: boolean;
    isLast: boolean;
    loading?: boolean;
}) {
  const [showTooltip, setShowTooltip] = useState(false);

  const totalFormatado = new Intl.NumberFormat('pt-BR').format(dadosAba.contador);

  return (
    <Container 
        abaAtiva={abaAtiva} 
        onClick={() => selecionaAba(dadosAba)}
        isFirst={isFirst}
        isLast={isLast}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
    >
        <span className="label">{dadosAba.label}</span>
        {
                loading && 
                <SkeletonText width="20px" height="16px" />
        }
        {!loading && 
            <span className="contador">{dadosAba.contador > 999 ? '999+' : dadosAba.contador}</span>
        }
        {!loading && showTooltip && (
          <Tooltip>{totalFormatado} demandas</Tooltip>
        )}
    </Container>
  );
}